export const component_map = {
	accordion: () => import("./Accordion"),
	annotatedimage: () => import("./AnnotatedImage"),
	audio: () => import("./Audio"),
	box: () => import("./Box"),
	button: () => import("./Button"),
	chatbot: () => import("./Chatbot"),
	checkbox: () => import("./Checkbox"),
	checkboxgroup: () => import("./CheckboxGroup"),
	code: () => import("./Code"),
	colorpicker: () => import("./ColorPicker"),
	column: () => import("./Column"),
	dataframe: () => import("./DataFrame"),
	dataset: () => import("./Dataset"),
	dropdown: () => import("./Dropdown"),
	file: () => import("./File"),
	form: () => import("./Form"),
	gallery: () => import("./Gallery"),
	group: () => import("./Group"),
	highlightedtext: () => import("./HighlightedText"),
	html: () => import("./HTML"),
	image: () => import("./Image"),
	interpretation: () => import("./Interpretation"),
	json: () => import("./Json"),
	label: () => import("./Label"),
	markdown: () => import("./Markdown"),
	model3d: () => import("./Model3D"),
	number: () => import("./Number"),
	plot: () => import("./Plot"),
	radio: () => import("./Radio"),
	row: () => import("./Row"),
	slider: () => import("./Slider"),
	state: () => import("./State"),
	statustracker: () => import("./StatusTracker"),
	tabs: () => import("./Tabs"),
	tabitem: () => import("./TabItem"),
	textbox: () => import("./Textbox"),
	timeseries: () => import("./TimeSeries"),
	uploadbutton: () => import("./UploadButton"),
	video: () => import("./Video")
};
